// 치과 환자관리 — 환자 화면·치과 화면 고정 문구 상수 (2026-09-10 1단계)
// 환자 웹 등록은 폐지(2026-09-10 저녁 대표 확정, 앱 전용). 동의 3항목·14세 게이트·등록 완료 문안은 앱에서 받으며
// 웹 상수에서 제거했다 — 문안 정본은 docs/환자동의_문안_2026-09-10.md.
// 규칙: 혜택·할인·무료·편리 등 유인 표현 금지(의료법), 「진료기록」·「차트」 단어 금지.

// 환자 화면(/p/) 하단 고정 문구
export const PATIENT_FOOT_NOTE = '이 화면은 보철물 제작 진행 사실만 안내합니다. 진료·비용에 관한 문의는 등록하신 치과로 해 주세요.';

// 치과 화면 — 상담·응대 메모 고정 문구 (법무 §2-4 ①)
export const MEMO_LABEL = '상담·응대 메모';
export const MEMO_NOT_RECORD = '진료에 관한 사항(증상·진단·처치·처방)은 의료기관의 진료기록부에 기록하세요. 이 메모는 진료기록부를 대체하지 않습니다.';
export const MEMO_MAX = 500;

// 업체 계정 로그인 상태에서 /p/ 접근 시 차단 문구 (실사 §3 권고)
export const BUSINESS_BLOCKED = '치과·기공소 계정으로 로그인되어 있어 환자 화면을 열 수 없습니다. 환자 본인 휴대폰의 덴탈클러스터 앱에서 진행하세요.';
